/* Landing2 — rediseño de la landing (Fase 1, ver plan-landing-rediseno.md).
 * Ensambla: hero IA (handoff "Hero A - dev 2") + secciones (handoff "Secciones Peicar").
 * Todo vive bajo <div className="lp2"> — los CSS están namespaced para no
 * chocar con PrimeReact/estilos globales del resto de la app. */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import './styles/hero.css';
import './styles/sections.css';

import HeroV3 from './components/hero/HeroV3';
import ContinueModal from './components/modals/ContinueModal';
import AnnouncementBar from './components/sections/AnnouncementBar';
import HeaderNuevo from './components/sections/HeaderNuevo';
import Partners from './components/sections/Partners';
import CreditoArrendamiento from './components/sections/CreditoArrendamiento';
import Incluido from './components/sections/Incluido';
import Proceso from './components/sections/Proceso';
import Fiscal from './components/sections/Fiscal';
import FinalCTA from './components/sections/FinalCTA';
import FooterNuevo from './components/sections/FooterNuevo';
import Fab from './components/sections/Fab';
import useReveal from './components/sections/useReveal';

import { waLink, DEFAULT_WA_MESSAGE } from './config';

/* Mapeo de las secciones viejas de la URL (/:section) a las anclas nuevas:
 * producto → #incluido, conoce → #fiscal; proceso se conserva. */
const SECTION_TO_ANCHOR = {
  incluido: 'incluido',
  producto: 'incluido',
  proceso: 'proceso',
  fiscal: 'fiscal',
  conoce: 'fiscal',
};

const scrollToHero = () => {
  document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
};

export default function Landing2() {
  const { section } = useParams();
  const [whatsOpen, setWhatsOpen] = useState(false);

  useReveal();

  useEffect(() => {
    if (!section) return;
    if (section === 'hablemos') { setWhatsOpen(true); return; }
    const anchor = SECTION_TO_ANCHOR[section.toLowerCase()];
    if (anchor) {
      // espera al primer paint para que las secciones existan
      requestAnimationFrame(() => {
        document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }, [section]);

  const openWhats = () => setWhatsOpen(true);

  return (
    <div className="lp2" id="top">
      {/* Fold de pantalla completa: bar + header + hero (ver .lp2-fold en hero.css) */}
      <div className="lp2-fold">
        <AnnouncementBar />
        <HeaderNuevo onWhats={openWhats} />
        <HeroV3 layout="stack" />
      </div>
      <Partners />
      <CreditoArrendamiento onQuote={scrollToHero} />
      <Incluido />
      <Proceso />
      <Fiscal />
      <FinalCTA onWhats={openWhats} onQuote={scrollToHero} />
      <FooterNuevo />
      {/*       <Fab onWhats={openWhats} /> */}

      {/* Modal genérico (header / CTA final / FAB): sin datos de cotización.
          El del hero (con resumen) lo maneja HeroV3 internamente. */}
      <ContinueModal
        open={whatsOpen}
        onClose={() => setWhatsOpen(false)}
        quote={null}
        onWhats={() => {
          window.open(waLink(DEFAULT_WA_MESSAGE), '_blank', 'noopener');
          setWhatsOpen(false);
        }}
        onQuote={() => { setWhatsOpen(false); scrollToHero(); }}
      />
    </div>
  );
}
